import TranslationRegistry from './classes/TranslationRegistry'
import _ from 'lodash'

let registerTranslations = window.environment && window.environment !== 'production'
let translations = window.i18n || {}

/**
 * Usage:
 * {{ trans('dashboard.welcome_text', 'Welcome back!') }} returns:
 * - Welcome back!
 *
 * {{ trans('dashboard.welcome_back', 'Welcome back, :user!', {user: 'Captain'}) }} returns:
 * - Welcome back, Captain!
 */

export const VueTrans = {
    install(Vue, options) {
        Vue.prototype.trans = (key, ...args) => {
            let locale = localStorage.getItem('locale');
            if (!locale) {
                locale = 'en';
            }

            let value = _.get(translations[locale], key)

            let hadValue = true;
            if (!value && args.length > 0) {
                value = args[0]
                hadValue = false;
            }

            if (!hadValue && registerTranslations) {
                TranslationRegistry.store(key, value)
            }

            if (args.length && typeof args[1] === 'object') {
                _.eachRight(args[1], (paramVal, paramKey) => {
                    value = _.replace(value, `:${paramKey}`, paramVal)
                });
            }

            return value
        }
    }
}
